export class InvalidField extends Error {
  public constructor(input: string) {
    super()

    this.message = `errors.invalidField.${input}`
  }
}
